// extracted by mini-css-extract-plugin
module.exports = {"main":"ExpandableDiv_main__bDNKx","label":"ExpandableDiv_label__Izn9i","expanded":"ExpandableDiv_expanded__jP4U8","content":"ExpandableDiv_content__aZsFp"};